// import { BUDGET_MODEL_URL } from "src/app/domain/fund-budget-model/pojo/bm-const";

import {MODELS_URLS} from "../../../../util/common/url-parts";

export const URL_PRESET = {
  entrance: {
    orgPicker: true,
    adminSwitcher: true,
    playShareOrgButtons: true,
    logo: true,
  },
  cabinet: {
    orgPicker: false,
    adminSwitcher: true,
    playShareOrgButtons: false,
    logo: false,
  },
  'organization-settings': {
    orgPicker: false,
    adminSwitcher: false,
    playShareOrgButtons: false,
    logo: false,
  },
  [MODELS_URLS.BASE]: {
    orgPicker: true,
    adminSwitcher: true,
    playShareOrgButtons: true,
    logo: true,
  },
};

